import React from "react";
import { Redirect } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import { withApollo } from "@apollo/react-hoc";
import Editor from "../../components/templates/editor";
import Loading from "../../components/atoms/loading";

import { showToast, t } from "../../utils/utils";
import API from "../../api/API";
import { GET_PROJECT_SLUG } from "../../api/projects";
import { GET_JWT, GET_REFRESH_JWT } from "../../constants";

class EditorPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      redirect: null,
      project: null,
    };
  }

  componentDidMount() {
    if (GET_JWT() && GET_REFRESH_JWT()) {
      this.getProject();
    } else {
      showToast(t("ingreseNuevamenteEmailClave"), "error");
      this.setState({
        redirect: "/",
      });
    }
  }

  async getProject() {
    const { client } = this.props;

    const { projectSlug } = this.props.match.params;
    if (projectSlug && projectSlug !== "") {
      //se cargan el proyecto segun slug
      try {
        const res = await API.query(client, GET_PROJECT_SLUG, {
          slug: projectSlug,
        });
        if (res && res.data && res.data.getProjectBySlug) {
          //console.log(res.data.getMyProjects);
          this.setState({ project: res.data.getProjectBySlug });
        } else {
          showToast(t("errorCargarProyecto"), "error");
        }
      } catch ({ graphQLErrors, networkError }) {
        if (graphQLErrors && graphQLErrors.length > 0) {
          showToast(graphQLErrors[0].message, "error");
        } else if (networkError) {
          showToast(t("errorCargarProyecto"), "error");
          this.setState({ redirect: "/" });
        } else {
          showToast(t("errorCargarProyecto"), "error");
          this.setState({ redirect: "/" });
        }
      }
      this.setState({ loading: false });
    } else {
      showToast(t("codigoInvalidoProyecto"), "error");
      this.setState({
        redirect: "/projects",
      });
    }
  }

  render() {
    const { loading, redirect, project } = this.state;
    if (redirect) return <Redirect to={redirect} />;
    if (loading)
      return (
        <Container>
          <Row>
            <Col xs="auto" className="mx-auto">
              <Loading />
            </Col>
          </Row>
        </Container>
      );

    return <Editor project={project} reload={() => this.getProject()} />;
  }
}

// Title.defaultProps = {
//   className: '',
//   children: '',
// }

export default withApollo(EditorPage);
